import module from '../module';
import Constants from  '../../../utils/CommonConstants';

function HeaderDirectiveController($scope, $window, $document, $rootScope) {

    $scope.onScroll = false;

    $scope.scrollToTop = function () {
        $window.scrollTo(0, 0);
    };

    function getElementsByClassName(className) {
        return $document[0].getElementsByClassName(className);
    }

    function handleWindowResize() {

        const document = $document[0];
        const header = document.getElementById('header');
        const footer = document.getElementById('footer');
        const body = $document.find('body')[0];
        const contents = document.getElementById('contents');

        $rootScope.contentsMinHeight = body.offsetHeight - header.offsetHeight - footer.offsetHeight;
    }

    $rootScope.$on(Constants.Events.WINDOW_WIDTH_CHANGED, handleWindowResize);
    // $rootScope.$on(Constants.Events.GROUP_ORDER_STATUS_CHANGED, () => {
    //     calculateNavbarHeight();
    //     $timeout(() => calculateNavbarHeight(), 200);
    //     $timeout(() => calculateNavbarHeight(), 400);
    // });

    $rootScope.$on(Constants.Events.WINDOW_SCROLL, function ($event, scrollTop) {
        $scope.onScroll = scrollTop > 0;
    });

    $scope.$on('groupOrderCreated', function () {
        handleWindowResize();
    });
}

module.directive('cartonomyHeader', function () {
    return {
        // templateUrl: 'modules/shared/views/header.html',
        template: require('../views/header.jade')(),
        controller: ['$scope', '$window', '$document', '$rootScope', HeaderDirectiveController]
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/HeaderDirective.js